import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import {
  fetchAWSCostReport,
  setAwsDataSyncDatetime,
  sortAWSCostTable
} from './../actions';
import {
  getSortedAnalyzedRunningInstancesCost,
  getAwsInstancesRequestStatus,
  getLastestAWSSyncDatetime
} from './../reducers';
import { aws, utils } from './../helpers';

import AWSInstancesCostComponent from './../Components/AWSInstancesCostComponent.jsx';


export class AWSInstancesCostContainer extends React.Component {
  static propTypes =
   { onFetch: PropTypes.func.isRequired };

  componentDidMount() {
    this.props.onFetch();
  }

  render() {
    return (
      <AWSInstancesCostComponent {...this.props} />
    );
  }
}

export const mapStateToProps = (state) => {
  const syncStatus = getAwsInstancesRequestStatus(state);
  const latestSyncDatetime = getLastestAWSSyncDatetime(state);
  const instances = getSortedAnalyzedRunningInstancesCost(state);
  const instancesGroupById = utils.propertyAccumulatorReducer(instances, 'id');
  return { instancesGroupById, syncStatus, latestSyncDatetime };
};

export const mapDispatchToProps = (dispatch) => ({
  onFetch: () => {
    const startDate = Moment().startOf('day').subtract(1, 'days').format('YYYY-MM-DD');
    const endDate = Moment().startOf('day').add(2, 'days').format('YYYY-MM-DD');
    dispatch(fetchAWSCostReport(
      aws.PERIODICITIES.DAILY,
      startDate,
      endDate
    ));
    dispatch(setAwsDataSyncDatetime(Moment().format('YYYY-MM-DD, h:mm:ss a')));
  },
  onSort: (sortingKey) => {
    dispatch(sortAWSCostTable(sortingKey));
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AWSInstancesCostContainer);


// WEBPACK FOOTER //
// src/Containers/AWSInstancesCostContainer.jsx